var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Checked"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "checkbox",
    width: 16,
    height: 16,
    rx: 4,
    fill: "#74788C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 5.9166L6.75004 10.9166L4.45837 8.62493L5.04587 8.03743L6.75004 9.73743L11.1625 5.3291L11.75 5.9166Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.407e76116637dd3dd8ca1354ff355057.svg";
export { ForwardRef as ReactComponent };